import { Spinner } from '@repo/ui'
import { observer } from 'mobx-react-lite'
import { Helmet } from 'react-helmet-async'
import { Redirect, Route, useRouteMatch } from 'react-router-dom'

import StoreService from '@/store/StoreService'

import { ChooseTriviaList } from './choose-trivia-list'
import { HomeScreenSettingsRoute } from '../../settings/pages/global-settings'

export const ChooseTriviaListRoute = observer(() => {
  const { path } = useRouteMatch()
  const { currentGame, isLoadingGame } = StoreService.getStore()

  if (isLoadingGame) {
    return <Spinner label='Loading...' />
  }

  if (currentGame) {
    return <Redirect to='/game' />
  } else {
    return (
      <>
        <Helmet>
          <title>Choose a Trivia List | Rockstar Bingo</title>
        </Helmet>

        <Route path='/settings'>
          <HomeScreenSettingsRoute />
        </Route>

        <Route path={path} exact>
          <ChooseTriviaList />
        </Route>
      </>
    )
  }
})
